<template>
    <div class="d-flex w-100">
        <multiselect v-model="selectedValue"
                     label="display_name"
                     :custom-label="customLabel"
                     track-by="id"
                     :placeholder="$t('designer.search_in_music_library')"
                     open-direction="bottom"
                     :options="songs"
                     :searchable="true"
                     :loading="loading"
                     :limit="1"
                     @search-change="searchChange"
                     @input="addSong"
        >
            <template slot="singleLabel" slot-scope="{ option }">
                <span>{{ option.select_name }}</span>
            </template>
            <template slot="option" slot-scope="{ option }">
                <div class="d-flex align-items-center">
                    <img style="width: 25px; height: 25px;" :src="option.cover ? `${searchUrl}/${option.id}/cover` : '/images/audio.png'" class="avatar rounded-circle float-left mr-2">
                    <span>{{ customLabel(option) }}</span>
                </div>
            </template>
            <template slot="afterList">
                <div v-observe-visibility="reachedEndOfList" v-if="page < lastPage"/>
            </template>
            <span slot="noResult">{{ $t('songlibrary.no_results') }}</span>
        </multiselect>
    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect';

    export default {

        props: {
            searchUrl: {
                required: true
            }
        },

        components: {
            Multiselect
        },

        data() {
            return {
                query: null,
                page: 1,
                lastPage: 1,

                loading: false,
                selectedValue: null,
                songs: []
            };
        },

        methods: {
            customLabel({display_name, author}) {
                let name = display_name;

                if (author) {
                    name += ' - ' + author;
                }

                return name;
            },

            searchChange(query) {
                return this.search(query, 1);
            },

            async search(query, page = 1) {
                if (page === 1) {
                    this.songs = [];
                }

                this.page = page;
                this.query = query;

                this.loading = true;

                try {
                    const response = await this.$http.get(this.searchUrl, {
                        params: {
                            page,
                            filters: JSON.stringify([
                                {
                                    or: true,
                                    field: 'display_name',
                                    like: `%${query}%`
                                },
                                {
                                    or: true,
                                    field: 'author',
                                    like: `%${query}%`
                                }
                            ])
                        }
                    });

                    this.lastPage = response.data.last_page;
                    this.songs = [...this.songs, ...response.data.data.filter(song => this.songs.findIndex(existingSong => existingSong.id === song.id) === -1)];
                } catch (exception) {
                }

                this.loading = false;
            },

            reachedEndOfList(reached) {
                if (reached) {
                    this.search(this.query, this.page + 1);
                }
            },

            addSong() {
                if (this.selectedValue) {
                    this.$emit('add-song', this.selectedValue.id);
                    this.selectedValue = null;
                }
            }
        }
    }
</script>
